export default __webpack_public_path__ + "5650afc51ebf135b2fd903be1171e4a3.png";